/**
 * Checks if the given name is a react event handler. Event handler names start
 * with "on", followed by a capital letter.
 */
export default function isEventHandler(name) {
    return /^on[A-Z]/.test(name);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/utils/isEventHandler.js
// module id = 1173
// module chunks = 0